/* Native forms handle search and cart. These menus only need dismissal behavior. */
(() => {
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.suy-header details[open]');
    if (!menu) return;
    menu.removeAttribute('open');
    menu.querySelector('summary')?.focus();
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.suy-header details[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
})();
